import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import { createBrowserRouter, RouterProvider } from "react-router-dom";

import App from "./App";
import Dashboard from "./components/licenciados/dashboard/Dashboard";
import Store from "./components/licenciados/store/Store";
import ExtratoCompleto from "./components/licenciados/Extrato/ExtratoCompleto";
import DadosBancarios from "./components/licenciados/dadosBancarios/DadosBancarios";
import PedidoSaque from "./components/licenciados/PedidoSaque/PedidoSaque";
import Ajuda from "./components/licenciados/Ajuda/Ajuda";

import Usuarios from "./components/admin/usuarios/Usuarios";
import AddUsuarios from "./components/admin/usuarios/AddUsuarios";
import LancarComissao from "./components/admin/LancarComissao/LancarComissao";
import Logs from "./components/admin/Logs/Logs";
import AdminDashboard from "./components/admin/dashboard/AdminDashboard";
import AdminSettings from "./components/admin/settings/AdminSettings";
import AdminStoreBanners from "./components/admin/storeBanners/AdminStoreBanners";
import AdminStoreCategories from "./components/admin/storeCategories/AdminStoreCategories";
import AdminStoreProducts from "./components/admin/storeProducts/AdminStoreProducts";

import { AuthProvider } from "./components/auth/AuthContext";
import RequireAuth from "./components/auth/RequireAuth";
import RequireRole from "./components/auth/RequireRole";
import EmBreve from "./components/EmBreve/EmBreve";

const router = createBrowserRouter([
  { path: "/", element: <App /> },
  { path: "/embreve", element: <EmBreve /> },

  {
    element: <RequireAuth />,
    children: [
      {
        element: <RequireRole allowed={["LICENSED"]} />,
        children: [
          { path: "/dashboard", element: <Dashboard /> },
          { path: "/store", element: <Store /> },
          { path: "/historico", element: <ExtratoCompleto /> },
          { path: "/extrato", element: <ExtratoCompleto /> },
          { path: "/lancamentos", element: <ExtratoCompleto /> },
          { path: "/dadosbancarios", element: <DadosBancarios /> },
          { path: "/solicitarsaque", element: <PedidoSaque /> },
          { path: "/ajuda", element: <Ajuda /> },
        ],
      },
      {
        element: <RequireRole allowed={["ADMIN"]} />,
        children: [
          { path: "/admin/dashboard", element: <AdminDashboard /> },
          { path: "/usuarios", element: <Usuarios /> },
          { path: "/adicionarusuarios", element: <AddUsuarios /> },
          { path: "/adicionarusuarios/:id", element: <AddUsuarios /> },
          { path: "/lancarcomissao", element: <LancarComissao /> },
          { path: "/logs", element: <Logs /> },
        ],
      },
      {
        element: <RequireRole allowed={["SUPER_ADMIN"]} />,
        children: [
          { path: "/configuracoes", element: <AdminSettings /> },
          { path: "/admin/store/categorias", element: <AdminStoreCategories /> },
          { path: "/admin/store/produtos", element: <AdminStoreProducts /> },
          { path: "/admin/store/banners", element: <AdminStoreBanners /> },
        ],
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </React.StrictMode>
);
